import { SaleRelatedModel } from 'api-hooks/order/common/model';
import { PurchaseRelatedModel } from 'api-hooks/sale/common';
import { NavigationRoutes } from 'common/constants';
import stylesColors from 'common/styles/styles.colors';
import { string2money } from 'common/utils/string';
import Separator from 'components/common/separator';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import useDate from 'hooks/use-date';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  data: SaleRelatedModel | null;
  navigation: {
    sale:
      | 'ActivitySalesView'
      | 'TicketSalesView'
      | 'HotelSalesView'
      | 'CruiseSalesView'
      | 'TravelDocumentSalesView';
    purchase:
      | 'ActivityPurchasesView'
      | 'FlightPurchasesView'
      | 'HotelPurchasesView'
      | 'CruisePurchasesView'
      | 'DocumentPurchasesView';
  };
}

export default function SaleRelatedTable(props: Props) {
  const { t } = useTranslation();
  const { data: _data, navigation } = props;

  const formatDate = useDate();

  const columns = React.useMemo<IColumn<PurchaseRelatedModel>[]>(
    () => [
      {
        header: t('common:type'),
        accessorKey: 'type',
        minSize: 150,
        cell: ({ getValue }) => t(`common:${getValue() as string}`),
      },
      {
        header: t('common:number_text'),
        accessorKey: 'number',
        minSize: 250,
      },
      {
        header: t('common:created_at'),
        accessorKey: 'createdAt',
        minSize: 200,
        cell: ({ getValue }) => <>{formatDate(getValue() as Date)}</>,
      },
      {
        header: t('common:total'),
        accessorKey: 'total',
        minSize: 250,
        cell: ({ getValue }) => `Rp ${string2money(getValue() as number)}`,
      },
    ],
    [formatDate, t],
  );

  const data = React.useMemo(() => {
    if (_data) {
      return [
        {
          id: _data.id,
          createdAt: _data.createdAt,
          number: _data.number,
          total: _data.total,
          type: 'sale_invoice',
        },
        ..._data.purchases.map((item) => ({
          ...item,
          type: 'purchase_order',
        })),
      ];
    }
    return [];
  }, [_data]);

  if (!data.length) {
    return <></>;
  }

  return (
    <>
      <TableComponent
        columns={columns}
        data={data || []}
        headerColor={stylesColors.bg1}
        showBorder
        rowLink={(row) => {
          return {
            pathname:
              NavigationRoutes[
                `${
                  row.original?.type === 'sale_invoice'
                    ? navigation.sale
                    : navigation.purchase
                }`
              ],
            query: {
              id: row.original?.id,
            },
          };
        }}
      />
      <Separator gap={16} />
    </>
  );
}
